import { ElNotification, type MessageOptions } from 'element-plus'
import type { EpPropMergeType } from 'element-plus/es/utils/vue/props/types'

export const useAlarm = () => {
  const messageStore = useMessageStore()
  const { userData } = storeToRefs(useUserData())
  const { storedCMDStack, messageStack } = storeToRefs(messageStore)
  const { runMessage } = messageStore
  const welcomeSur = computed(() => userData.value?.userName.concat('님!') ?? '')
  onMounted(() => {
    proceedStoredCMD()
    runMessage()
    function proceedStoredCMD() {
      const { t } = useLocale()
      const cmd = storedCMDStack.value.shift()
      switch (cmd) {
        case 'redirectAfterLogin':
          // message('info', t('messages.purchaseRetry'), false, true, 2000, 90, 'message-plain')
          break
        case 'welcome':
          break
        default:
          break
      }
      if (storedCMDStack.value.length > 0) {
        proceedStoredCMD()
      }
    }
  })

  const notify = (
    title: string,
    type:
      | EpPropMergeType<StringConstructor, '' | 'success' | 'warning' | 'info' | 'error', unknown>
      | undefined,
    message: string,
    showClose: boolean,
    duration: number,
    offset: number,
    customClass: string
  ) => {
    ElNotification({
      title,
      message,
      showClose,
      type,
      duration,
      offset,
      customClass
    })
  }

  const message = (
    type:
      | EpPropMergeType<StringConstructor, 'success' | 'warning' | 'info' | 'error', unknown>
      | undefined,
    message: string,
    showClose: boolean,
    center: boolean,
    duration: number,
    offset: number,
    customClass: string = 'message-plain'
  ) => {
    if (!messageStack.value.find((item: MessageOptions) => item.message === message)) {
      messageStack.value.push({
        type,
        message,
        showClose,
        center,
        duration,
        offset,
        customClass
      })
      runMessage()
    }
  }

  const returnErrorMessage = (messageData: any, extraText: string) => {
    if (messageData.data.statusCode >= 300) {
      notify(
        '',
        'warning',
        messageData.data.message.concat(': ', String(messageData.data.statusCode)),
        true,
        3000,
        0,
        ''
      )
      return
    }
    const errorMessage = messageData.data.error.message
    switch (messageData) {
      case true:
        notify('', 'warning', extraText, true, 3000, 0, '')
        break
      default:
        notify('', 'warning', errorMessage, true, 3000, 0, '')
    }
  }

  return {
    notify,
    message,
    returnErrorMessage,
    messageStack,
    storedCMDStack,
    runMessage
  }
}
